import { getCurrentUserID } from 'src/modules/authentication/storage/user/utils';
import QPAPIs from '../../db/question-paper';
import { mapPaginatedQPs, mapQPToNode } from './utils';
export const epQPQueries = {
    async ep_qp(_, { qpID }, context) {
        const result = await QPAPIs.getByID(getCurrentUserID(), qpID);
        return mapQPToNode(result);
    },
    async ep_qpList(_, { pagination, subjectID }, context) {
        const result = await QPAPIs.getList(getCurrentUserID(), subjectID, pagination);
        return mapPaginatedQPs(result);
    },
};
